import { useEffect } from 'react';

/**
 * iOS Safari でソフトキーボードが開いた時に `visualViewport.height` を
 * `--app-height` CSS var に書き戻し、レイアウトがキーボードに食われないようにする。
 * `100dvh` のみだと iOS Safari で完全に追従しないケースがあるため補完する。
 */
export function useVisualViewport(): void {
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      document.documentElement.style.setProperty('--app-height', `${vv.height}px`);
    };
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
}
